var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticStyle:{"all":"unset","position":"absolute","width":"100%","height":"100%","background":"transparent","cursor":"pointer"},attrs:{"to":_vm.route}})}
var staticRenderFns = []

export { render, staticRenderFns }